import { render } from "./GroupInsuranceDocuments.vue?vue&type=template&id=46e107d5&ts=true"
import script from "./GroupInsuranceDocuments.vue?vue&type=script&lang=ts"
export * from "./GroupInsuranceDocuments.vue?vue&type=script&lang=ts"

import "./GroupInsuranceDocuments.vue?vue&type=style&index=0&id=46e107d5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__